import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

// Connects to data-controller="tooltip"
export default class extends Controller {
  static values = {
    content: { type: String, default: "" },
    placement: { type: String, default: "top" },
    key: { type: String, default: "" },
  };

  connect() {
    this.initTooltip();
  }

  disconnect() {
    if (this.tippyInstance) {
      this.tippyInstance.destroy();
      this.tippyInstance = null;
    }
  }

  initTooltip() {
    // Skip if no content
    if (!this.contentValue || this.contentValue.trim() === "") {
      return;
    }

    // Detect dark mode
    const isDarkMode = document.documentElement.classList.contains("dark");

    this.tippyInstance = tippy(this.element, {
      content: this.contentValue,
      placement: this.placementValue,
      allowHTML: true,
      interactive: true,
      appendTo: document.body,
      maxWidth: 320,
      trigger: "mouseenter focus",
      // Theme based on light/dark mode
      theme: isDarkMode ? "light" : "dark",
      // Animation
      animation: "fade",
      duration: [200, 150],
      // Touch support for mobile
      touch: ["hold", 500],
      // Accessibility
      aria: {
        content: "describedby",
      },
      offset: [0, 8],
      // Hide on scroll for mobile
      hideOnClick: true,
      zIndex: 9999,
    });
  }

  // Method to update content dynamically if needed
  contentValueChanged() {
    if (this.tippyInstance) {
      this.tippyInstance.setContent(this.contentValue);
    } else {
      this.initTooltip();
    }
  }

  // Re-initialize when placement changes
  placementValueChanged() {
    if (this.tippyInstance) {
      this.tippyInstance.setProps({ placement: this.placementValue });
    }
  }
}
